// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/file-check.js';

import { paths } from '../generated/file-check';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('file-check', Original, paths);
